import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ion-padding" }
const _hoisted_2 = { class: "infinite-scroll-content" }

import { IonPage, IonContent, IonItem, IonLabel, IonInfiniteScroll, IonTitle, IonToolbar, IonHeader, IonItemOption } from '@ionic/vue';
import { BasicModal, BasicSpinner } from '@components/basic'
import BasicNormalInput from '@components/basic/form-elements/BasicNormalInput.vue';
import BasicEntryDocumentList from '@/components/basic/list/BasicEntryDocumentList.vue';
import useScanner from '@/composable/useScanner';
import useGetEntryDeliveryDocuments from './_inner/useGetEntryDeliveryDocuments';
import useAggregationPlacementModal from "@/composable/useAggregationPlacementModal";
import BasicEntryModalContent from '@/components/basic/BasicEntryModalContent.vue';
import ArticleQuantityCardBase from '@/components/article/ArticleQuantityCardBase.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectEntryDocumentView',
  setup(__props) {

const {
  loadMore,
  foundType,
  searchCode,
  documents,
  maxDocuments,
  isLoading,
} = useGetEntryDeliveryDocuments()

const {
  articlesModal,
  canLoadMoreItems,
  loadNextRows,
  articlesModalItems,
  storeEntriesData,
} = useAggregationPlacementModal(['placementsRelatedForZD.product', 'placementsRelatedForZD.combination', 'placementsRelatedForZD.combination.product', 'placementsRelatedForZD'],8)

const handleShowProducts = async (documentId: number) => {
  return storeEntriesData(documentId);
};

useScanner({ onScan(code) { 
  searchCode.value = code
}});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode("WMS | Select ZD")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_unref(IonItem), {
              class: "ion-no-padding ion-margin-bottom",
              style: {"margin":"0 15px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(IonLabel), { position: "stacked" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Code: "),
                    _withDirectives(_createElementVNode("span", null, "(matched by: " + _toDisplayString(_unref(foundType)) + ")", 513), [
                      [_vShow, _unref(foundType)]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(BasicNormalInput, {
                  name: "code",
                  modelValue: _unref(searchCode),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(searchCode) ? (searchCode).value = $event : null))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _withDirectives(_createElementVNode("div", _hoisted_1, " No documents found. ", 512), [
              [_vShow, !_unref(isLoading) && _unref(maxDocuments) == 0]
            ]),
            _createVNode(BasicEntryDocumentList, {
              documents: _unref(documents),
              route: "delivery/create-delivery-document"
            }, {
              default: _withCtx(({ document }) => [
                _createVNode(_unref(IonItemOption), {
                  color: "primary",
                  onClick: ($event: any) => (handleShowProducts(document.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Products ")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["documents"]),
            _createVNode(_unref(IonInfiniteScroll), { onIonInfinite: _unref(loadMore) }, {
              default: _withCtx(() => [
                _withDirectives(_createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(BasicSpinner), { "is-loading": true })
                ], 512), [
                  [_vShow, _unref(documents).length < _unref(maxDocuments) || _unref(isLoading)]
                ])
              ]),
              _: 1
            }, 8, ["onIonInfinite"])
          ]),
          _createVNode(_unref(BasicModal), {
            modelValue: _unref(articlesModal).isOpen,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(articlesModal).isOpen) = $event))
          }, {
            title: _withCtx(() => [
              _createTextVNode(" Produkty ")
            ]),
            default: _withCtx(() => [
              _createVNode(BasicEntryModalContent, {
                onLoadMoreItems: _unref(loadNextRows),
                "can-load-more": _unref(canLoadMoreItems),
                "is-loading": _unref(articlesModal).isLoading
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articlesModalItems), (article) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: article.document_product_id
                    }, [
                      _createVNode(ArticleQuantityCardBase, { article: article }, {
                        right: _withCtx(() => [
                          _createTextVNode(_toDisplayString(article.scanned_quantity) + "/" + _toDisplayString(article.declared_quantity) + " szt. ", 1)
                        ]),
                        _: 2
                      }, 1032, ["article"])
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["onLoadMoreItems", "can-load-more", "is-loading"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})